import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getVisibleBoxPaymentMethods } from '@/utils/paymentMethods';
import { PaymentMethod } from '../PaymentMethod/PaymentMethod';

export const PaymentMethods = () => {
  const { paymentMethodsAvailable } = useContext(CheckoutContext);
  const methods = getVisibleBoxPaymentMethods(paymentMethodsAvailable);

  // With a single (or zero) selectable method there's nothing to choose
  // between, so the lone highlighted box just adds visual noise — hide the
  // picker entirely. Only the DEFAULT template renders this row
  // (SINGLE/PREFERRED set `showPaymentMethods: false`), so this is naturally
  // scoped to DEFAULT.
  if (methods.length <= 1) {
    return null;
  }

  return (
    <div data-testid="payment-methods-list" className="flex flex-row justify-between gap-2">
      {methods.map((pm) => (
        <PaymentMethod key={pm.paymentMethodName} method={pm} />
      ))}
    </div>
  );
};
